/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListConnectionsByStationQueryResponse, SocialExportListConnectionsByStationPathParams, SocialExportListConnectionsByStation400, SocialExportListConnectionsByStation401, SocialExportListConnectionsByStation403, SocialExportListConnectionsByStation404 } from "../models/SocialExportListConnectionsByStation";

export function getSocialExportListConnectionsByStationUrl(station: SocialExportListConnectionsByStationPathParams["station"]) {
  const res = { method: 'GET', url: `/social-export/v1/connections/by-station/${station}` as const }
  return res
}

/**
 * @description Returns connections linked to the given station, including global lastUsedAt, lastUsedForStationAt, and platform media limits for this station.
 * @summary List connection states assigned to a station
 * {@link /social-export/v1/connections/by-station/:station}
 */
export async function socialExportListConnectionsByStation(station: SocialExportListConnectionsByStationPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportListConnectionsByStationQueryResponse, ResponseErrorConfig<SocialExportListConnectionsByStation400 | SocialExportListConnectionsByStation401 | SocialExportListConnectionsByStation403 | SocialExportListConnectionsByStation404>, unknown>({ method : "GET", url : getSocialExportListConnectionsByStationUrl(station).url.toString(), ... requestConfig })
  return res.data
}